import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect } from "react";
import Download from "../components/Download";
import ErrorMessage from "../components/ErrorMessage";
import ErrorTitle from "../components/ErrorTitle";
import { formLabel } from "../utils/formFieldLabels";

const CivilIdDocument = ({
  formData,
  handleChange,
  showError,
  errors,
  documentError,
  documentErrorMsg
}) => {
  useEffect(() => {
    document.title = "AUMS • Document";
  }, []);

  const isKuwaiti = formData?.nationality?.value === "Kuwait";
  const isNonKuwaiti = formData?.nationality?.value === "Non Kuwaiti";

  const documentRows = [
    {
      title: "Official Grade Transcript or certified copy – original High school certificate",
      items: [{ key: "transcript", label: "" }]
    },
    {
      title: "Equivalency of high school certificate issued by the Ministry of Education in Kuwait (for private school graduates)",
      items: [{ key: "equivalency", label: "" }]
    },
    {
      title: "Valid IELTS / TOEFL score report (no older than two years)",
      items: [{ key: "englishscore", label: "" }]
    },
    {
      title: "Copy of Birth certificate",
      items: [{ key: "birthCertificate", label: "" }]
    },
    {
      title: "Valid National ID – CIVIL ID (Front & Back)",
      items: [
        { key: "civilidFront", label: "1. Civil ID FRONT COPY" },
        { key: "civilidBack", label: "2. Civil ID BACK COPY" }
      ]
    },
    ...(isNonKuwaiti ? [
      {
        title: "Security Card (Front & Back)",
        items: [
          { key: "securityCardFront", label: "1. FRONT COPY" },
          { key: "securityCardBack", label: "2. BACK COPY" }
        ]
      }
    ] : []),
    {
      title: "Valid Passport Copy",
      items: [{ key: "passport", label: "" }]
    },
    {
      title: "Passport size Photograph",
      items: [{ key: "photograph", label: "" }]
    },
    {
      title: "Certificate of Good Conduct",
      items: [{ key: "goodconduct", label: "" }]
    },
    {
      title: "Father Civil ID",
      items: [{ key: "fatherCivilId", label: "" }]
    },
    {
      title: "Father Passport Copy",
      items: [{ key: "fatherPassport", label: "" }]
    },
    {
      title: "Mother Civil ID",
      items: [{ key: "motherCivilId", label: "" }]
    },
    {
      title: "Mother Passport copy",
      items: [{ key: "motherPassport", label: "" }]
    },
    ...(isKuwaiti ? [
      {
        title: "Certificate of Nationality for Father – (From Sahel App)",
        items: [{ key: "sahel", label: "" }]
      }
    ] : []),
    {
      title: "Other Documents",
      items: [{ key: "otherDocuments", label: "" }]
    }
  ];

  return (
    <Box sx={{}}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "#b60041",
          padding: "1rem",
          fontWeight: "bold"
        }}
      >
        <h4 className="form">Required Documents { " / المستندات المطلوبة " }</h4>
      </Box>

      <Box sx={{ padding: "0.5rem", color: "#606060" }}>
        <Box>
          <h4 className="my-3 font-bold text-center">
            {formLabel.document.title.english}      
          </h4>
          <div className="px-4">{showError && <ErrorTitle />}</div>
          <div className="px-4">
            {documentError && <ErrorMessage errorMessage={documentErrorMsg} />}
          </div>
        </Box>

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead className="w-full ">
              {documentRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell sx={{ fontWeight: "700" }} align="left">
                    <span className="font-bold">{row.title}</span>
                    {row.items.map((item, i) => (
                      <React.Fragment key={i}>
                        {item.label && (
                          <>
                            <br />
                            {item.label}
                          </>
                        )}
                        {errors && errors[item.key] && (
                          <ErrorMessage errorMessage={errors[item.key]} />
                        )}
                      </React.Fragment>
                    ))}
                  </TableCell>
                  <TableCell align="right" className="w-[300px]">
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", alignItems: "flex-end" }}>
                      {row.items.map((item, i) => (
                        <Download
                          key={i}
                          errors={errors}
                          formData={formData}
                          handleChange={handleChange}
                          value={item.key}
                        />
                      ))}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableHead>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default CivilIdDocument;
